'use client'
import { createContext } from 'react'
import { styled } from "styled-components";
import { MdArrowForward, MdKeyboardArrowRight } from 'react-icons/md'
import hexToRgbA from '../HexToRGBA';


export const ContentWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
position: relative;
padding:  0 2%;
height: 100%;
background: ${props => props.theme.mainBg};
color: ${props => props.theme.secondaryBg}l

:before {
    content: '';
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

`

export const ContentBg = styled.div`
display: flex;
position: relative;
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100%;
height: 100%
`

export const VideoBg = styled.video`
display: flex;
position: relative;
width: 100%;
height: 100%;
-o-object-fit: cover;
object-fit: cover;
border-radius: 25px;
background: ${props => props.theme.mainBg};
`

export const ContentContent = styled.div`
z-index: 3;
max-width: 1200px;
position: absolute;
padding: 8px 24px;
display: flex;
flex-direction: column;
align-items: center;
`

export const ContentH1 = styled.h1`
    display: flex;
    position: relative;
    color: ${props => (props.color ? props.color: props.theme.mainColor)};
    font-size: 48px;
    text-align: center;

    @media screen and (max-width: 768px) {
        font-size: 40px;
    }

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`

export const ContentP = styled.p`
margin-bottom: 24px;
font-size: 24px;
text-align: center;
max-width: 600px;
color: ${props => props.theme.secondaryBg};
@media screen and (max-width: 768px) {
    font-size: 24px;
}

@media screen and (max-width: 480px) {
    font-size: 18px;
}
`

export const ContentBtnWrapper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-item: center;
`

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;

`

export const ArrowRight = styled(MdKeyboardArrowRight)`
margin-left: 8px;
font-size: 20px;
`